<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useReveal } from '../composables/useReveal'

const { t } = useI18n()
const { elementRef: sectionRef, isVisible } = useReveal(0.2)

const stats = ['efficiency', 'load', 'inventory', 'audit']
</script>

<template>
  <section ref="sectionRef" class="section stats">
    <div class="container-narrow stats__header">
      <h2 :class="['reveal', { visible: isVisible }]">{{ t('stats.title') }}</h2>
      <p :class="['reveal', 'reveal-delay-1', { visible: isVisible }]">{{ t('stats.subtitle') }}</p>
    </div>

    <div class="container stats__grid">
      <div
        v-for="(stat, index) in stats"
        :key="stat"
        :class="['stat-card', 'reveal', `reveal-delay-${Math.min(index + 1, 4)}`, { visible: isVisible }]"
      >
        <div class="stat-card__value">{{ t(`stats.items.${stat}.value`) }}</div>
        <div class="stat-card__label">{{ t(`stats.items.${stat}.label`) }}</div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.stats {
  background: var(--color-surface);
  text-align: center;
}

.stats__header {
  margin-bottom: 4rem;
}

.stats__header h2 {
  margin-bottom: 1rem;
  color: var(--color-dark);
}

.stats__grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;
}

.stat-card {
  padding: 2.5rem 1.5rem;
  border-radius: var(--radius-lg);
  background: var(--color-bg-elevated);
  border: 1px solid var(--color-border);
}

.stat-card__value {
  font-family: var(--font-display);
  font-size: clamp(2.5rem, 5vw, 3.5rem);
  font-weight: 700;
  color: var(--color-dark);
  line-height: 1;
  margin-bottom: 0.75rem;
}

.stat-card__label {
  font-size: 0.9375rem;
  font-weight: 500;
  color: var(--color-text-secondary);
}

@media (max-width: 900px) {
  .stats__grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 480px) {
  .stats__grid {
    grid-template-columns: 1fr;
  }
}
</style>
